import React from 'react';

const Pptx = ({
  color,
  height,
  width,
}: {
  color?: string;
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={width ?? '48px'}
      height={height ?? '48px'}
    >
      <path
        fill="#FF8A65"
        d="M41,10H25v28h16c0.553,0,1-0.447,1-1V11C42,10.447,41.553,10,41,10z"
      />
      <path
        fill="#FBE9E7"
        d="M24 29H38V31H24zM24 33H38V35H24zM30 15c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6h-6V15z"
      />
      <path fill="#FBE9E7" d="M32,13v6h6C38,15.687,35.313,13,32,13z" />
      <path fill="#E64A19" d="M27 42L6 38 6 10 27 6z" />
      <path
        fill="#FFF"
        d="M16.828,17H12v14h3v-4.823h1.552c1.655,0,2.976-0.436,3.965-1.304c0.988-0.869,1.484-2.007,1.482-3.412C22,18.487,20.275,17,16.828,17z M16.294,23.785H15v-4.364h1.294c1.641,0,2.461,0.72,2.461,2.158C18.755,23.051,17.935,23.785,16.294,23.785z"
      />
    </svg>
  );
};

export default Pptx;
